import client from '../httpClient';

const directRegistApi = (params) => {
  return client.post('/directs/', params, { isShowLoading: false });
};

export default directRegistApi;
